import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, FieldLabel, FieldWrapper, FlexBox, HelpIcon, } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import { Options } from './components/options/options';
import styles from './optionsFormField.module.scss';
const optionFieldHelpTextMap = {
    order_index: {
        title: 'Order',
        description: 'The options can be arranged to appear in a specific order.',
    },
    label: {
        title: 'Label',
        description: 'Something that the agents can easily interpret and understand.',
    },
    value: {
        title: 'Value',
        description: 'Unique identifier used to represent the data in API and exports.',
    },
    is_deactivated: {
        title: 'Active',
        description: 'Deactivated options will not appear in usages of custom select attribute.',
    },
};
const helpIconText = (_jsxs(_Fragment, { children: [_jsx("div", { children: "Select attribute options that will be available to agents to select from." }), Object.values(optionFieldHelpTextMap).map(({ title, description }, index) => (_jsxs(Fragment, { children: [_jsx("br", {}), _jsx("strong", { children: title }), _jsx("div", { children: description })] }, index)))] }));
/** Represents the field for managing options of a custom select attribute. */
export const OptionsFormField = () => {
    var _a, _b, _c;
    // TODO: [TEAMS-13693] add `AttributeFormFieldValuesHavingOptions` generic back after updating to RHF v8
    const { formState } = useFormContext();
    return (_jsx(FieldWrapper, Object.assign({ label: "Options", required: true, meta: {
            error: formState.errors.options
                ? (_c = (_b = (_a = formState.errors.options.root) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : 'Some options appear to be invalid'
                : undefined,
        }, helpIcon: {
            dark: true,
            text: helpIconText,
        } }, { children: _jsx(Box, Object.assign({ background: colors.neutral[100], padding: "250 0", borderRadius: "100" }, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", width: "100%" }, { children: [_jsxs(Box, Object.assign({ className: styles.head }, { children: [_jsx(Box, {}), _jsx(FieldLabel, Object.assign({ required: true }, { children: "Label" })), _jsx(FieldLabel, Object.assign({ required: true }, { children: "Value" })), _jsx(Box, {}), _jsx(Box, {}), _jsx(FlexBox, Object.assign({ justifyContent: "center" }, { children: _jsx(HelpIcon, { text: _jsx(_Fragment, { children: "Whether the option is active." }), dark: true }) }))] })), _jsx(Options, {})] })) })) })));
};
